import React, { useState, useEffect } from "react";
import axios from "axios";
import AOS from "aos";
import "aos/dist/aos.css";
import StripeCheckout from "react-stripe-checkout";
import { useParams } from "react-router-dom";

import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader";
import Error from "../components/Error";
import swal from "sweetalert2";
import moment from "moment";
function BookingRoom() {
	let { id, todate, fromdate } = useParams();
	const [room, setrooms] = useState([]);
	const [loading, setloading] = useState(true);
	const [error, seterror] = useState();
	const navigate = useNavigate();
	const firstdate = moment(fromdate, "DD-MM-YYYY");
	const lastdate = moment(todate, "DD-MM-YYYY");
	const totaldays = moment.duration(lastdate.diff(firstdate)).asDays() + 1;
	const totalamount = totaldays * room.rentperday;
	useEffect(() => {
			AOS.init({ duration: 500 });
		if (!localStorage.getItem("currentuser")) {
			navigate("/login");
		}
		try {
			setloading(true);
			axios
				.post("https://online-hotels-booking-system-server.vercel.app/api/rooms/getroombyid", { roomid: id })
				.then((response) => {
					setrooms(response.data);
					setloading(false);
				});
		} catch (error) {
			seterror(true);
			setloading(false);
		}
	}, []);

	async function onToken(token) {
		console.log(token);
		const bookingDetails = {
			room,
			userid: JSON.parse(localStorage.getItem("currentuser"))._id,
			userName: JSON.parse(localStorage.getItem("currentuser")).name,
			fromdate,
			todate,
			totalamount,
			totaldays,
			token,
		};

		try {
			setloading(true);
			const result = axios
				.post("https://online-hotels-booking-system-server.vercel.app/api/bookings/bookroom", bookingDetails)
				.then((response) => {});
			setloading(false);
			swal
				.fire("Congratulation", "Your Room Booked Successfully", "success")
				.then((result) => {
					navigate("/mybookngs");
				});
		} catch (error) {
			setloading(false);
			swal.fire("Oops", "Simething went wrong", "error");
		}
	}

	return (
		<div className="m-5 ">
			{loading ? (
				<Loader />
			) : room ? (
				<div
					data-aos="flip-down"
					className="row  justify-content-center mt-5 bs">
					<div className="col-md-5">
						<h1>{room.name}</h1>
						<img src={room.imageurls[0]} className="bigimg" />
					</div>

					<div className="col-md-5">
    <div style={{ textAlign: "right", color: "#333", backgroundColor: "#f8f9fa", padding: "15px", borderRadius: "5px", boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)" }}>
        <h1 style={{ color: "#007bff" }}>Booking Details</h1>
        <hr />
        <b>
            <p>Name: {JSON.parse(localStorage.getItem("currentuser")).name}</p>
            <p>From Date: {fromdate}</p>
            <p>To Date: {todate}</p>
            <p>Max Count: {room.maxcount}</p>
        </b>
    </div>

    <div style={{ textAlign: "right", color: "#333", backgroundColor: "#f8f9fa", padding: "15px", borderRadius: "5px", boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)", marginTop: "20px" }}>
        <b>
            <h1 style={{ color: "#007bff" }}>Amount</h1>
            <hr />
            <p>Total days: {totaldays}</p>
            <p>Rent per day: ₦{room.rentperday}</p>
            <p>Total Amount: ₦{totalamount}</p>
        </b>
    </div>

    <div style={{ float: "right", marginTop: "20px" }}>
        <StripeCheckout
            amount={totalamount * 100}
            token={onToken}
            stripeKey="pk_test_51MRz64ANvs12nqLSjhcnG1QT7pFOGqj6hPdmlyIFIro8Cycehi90TkJaAPsmwwwaXB1LG8k28MjDcxxc9MuSuPqx00245ihXpK"
            currency="NGN">
            <button className="btn btn-primary">Pay Now</button>
        </StripeCheckout>
    </div>
</div>
				</div>
			) : (
				<Error />
			)}
		</div>
	);
}

export default BookingRoom;
